import React, { useState } from 'react'
import { View, Image, ImageSourcePropType } from 'react-native'
import { useStore } from '../../../../../store'
import { observer } from 'mobx-react'
import { CardIconBuilder, IconDelete } from '../../../../../assets/icons'
import { ListPlaceholder } from '../../../../../ui/atoms/ListPlaceholder'
import { DeleteListItemIcon } from '../../../../../assets/icons'
import SwipableListItem from '../../../../../ui/molecules/SwipableListItem'
import { theme } from '@linqpal/common-frontend'
import noCardImage from '../../../../../assets/images/builder2.0/MoreCards.svg'
import { ScrollView } from 'react-native-gesture-handler'
import { useTranslation } from 'react-i18next'
import { ConfirmPrompt } from '../../../../../ui/molecules/ConfirmPrompt'
import { ListItem } from '../../../../../ui/atoms/builder-2.0/ListItem'
import { IBankAccountModel } from '@linqpal/models'
import { Spacer } from '../../../../../ui/atoms'

const { commonColors } = theme

interface CardsProps {
  onPress?: (arg: IBankAccountModel) => void
}
interface ConfirmDeleteProps {
  visible: boolean
  setModal: (arg: boolean) => void
  deleteMethod: () => void
}

const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
  visible,
  setModal,
  deleteMethod,
}) => {
  const { t } = useTranslation('global')
  return (
    <ConfirmPrompt
      visible={visible}
      onDismiss={() => {
        setModal(false)
      }}
      icon={<IconDelete />}
      title={t('Wallet.confirm_action')}
      message={t('Wallet.please_confirm_to_delete')}
      secondButton={{
        title: t('Wallet.go_back'),
        mode: 'contained',
        bgColor: commonColors.accentText,
        onPress: () => {
          setModal(false)
        },
      }}
      firstButton={{
        title: t('Wallet.yes_delete'),
        mode: 'contained',
        bgColor: 'rgba(242, 90, 104, 0.1)',
        textColor: '#DA515E',
        onPress: () => deleteMethod(),
      }}
      exitable={false}
    />
  )
}

export const Cards: React.FC<CardsProps> = observer(function Cards({
  onPress,
}) {
  const { t } = useTranslation('global')
  const [deleteModal, setDeleteModal] = useState(false)
  const [paymentMethodToDelete, setPaymentMethodToDelete] =
    useState<IBankAccountModel | null>(null)

  const { screensStore } = useStore()
  const { cards, cardsEmpty } = screensStore.paymentMethodsStore

  const deletePaymentMethod = () => {
    screensStore.paymentMethodsStore.setPaymentMethod({
      ...paymentMethodToDelete,
      action: 'delete',
    })
    setDeleteModal(false)
  }

  return (
    <>
      <ScrollView style={{ backgroundColor: 'white' }}>
        {cardsEmpty ? (
          <NoCardsAdded />
        ) : (
          cards.map((card, index) => (
            <SwipableListItem
              key={card.id}
              rightActions={
                !(card.paymentMethodType === 'card' && !card.isManualEntry)
                  ? [
                      {
                        icon: <DeleteListItemIcon />,
                        handler: () => {
                          setPaymentMethodToDelete(card)
                          setDeleteModal(true)
                        },
                      },
                    ]
                  : []
              }
              rightActionStyle={{ marginBottom: 20 }}
            >
              <ListItem
                key={index}
                icon={<CardIconBuilder style={{ height: 40, width: 40 }} />}
                endIcon={<View />}
                title={card.name || t('Wallet.credit_debit_card')}
                subtitle={`${card.accountNumber}`}
                otherStyles={{
                  title: { lineHeight: 26 },
                  container: { paddingHorizontal: 0 },
                }}
                onPress={() => onPress && onPress(card)}
              />
            </SwipableListItem>
          ))
        )}
        <Spacer height={50} />
      </ScrollView>
      <ConfirmDelete
        visible={deleteModal}
        setModal={setDeleteModal}
        deleteMethod={deletePaymentMethod}
      />
    </>
  )
})

const NoCardsAdded: React.FC = () => {
  const { t } = useTranslation('global')
  return (
    <ListPlaceholder
      image={
        <Image
          style={{
            width: 202,
            height: 152,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          source={noCardImage as ImageSourcePropType}
        />
      }
      heading={t('Wallet.no_card_linked_yet')}
      subHeading={t('Wallet.tap_to_link_your_card')}
    />
  )
}
